import React from "react";
import DynamicLogin from "./DynamicLogin";
import AlertBanner from "../components/AlertBanner";
import { Title } from "react-admin";
import SosLogo from "../components/SosLogo.js";

const sosTechNotice = (
  <div style={{ padding: "1rem" }}>
    <h2 style={{ margin: "0" }}>
      This is a notice for accessing a System provided for SOS-Tech-authorized
      use only. By using this System, you agree to the following:
    </h2>
    <ul>
      <li>
        Access is restricted to authorized SOS-Tech employees and contractors.
        Unauthorized use is prohibited and subject to criminal and civil
        penalties.
      </li>
      <li>
        SOS-Tech intercepts and monitors communications and may inspect and
        seize data at any time.
      </li>
      <li>
        Communications and data are not private and may be used for
        SOS-Tech-authorized purposes.
      </li>
      <li>
        Security measures protect SOS-Tech interests, not your personal benefit
        or privacy.
      </li>
      <li>
        However, using this System does not constitute consent to monitoring of
        privileged communications related to personal representation or services
        by attorneys, psychotherapists, or clergy and their assistants. Such
        communications and work products are private and confidential.
      </li>
    </ul>
  </div>
);

export default function Login() {
  const loginStyle = {
    display: "flex",
    flexDirection: "column",
    height: "100vh", // Adjust based on requirements
    background: "#fff",
  };

  const flexCenter = {
    flex: 1, // This will make the div take up all available space
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "5rem",
  };
  return (
    <div style={loginStyle}>
      <SosLogo />
      <div style={flexCenter}>
        <DynamicLogin />
      </div>
      <AlertBanner severity="warning" message={sosTechNotice} />
    </div>
  );
}
